(ns rlws.iot-cloud.frontend.storage
  (:require [akiroz.re-frame.storage :as rf.storage]
            [alandipert.storage-atom :as storage-atom]
            [cognitect.transit :as transit]
            [java.time :refer [Instant]]
            [tick.alpha.api :as tick]))

(def write-handlers
  {Instant (transit/write-handler 'instant str)})

(def read-handlers
  {'instant (transit/read-handler tick/parse)})

(defn init-storage!
  [app-name]
  (swap! alandipert.storage-atom/transit-write-handlers merge write-handlers)
  (swap! alandipert.storage-atom/transit-read-handlers merge read-handlers)
  (rf.storage/reg-co-fx!
   app-name
   {:fx :store
    :cofx :store}))

(comment

  (swap! some-atom assoc :hello "world!")
  (swap! some-atom assoc :timestamp (tick.alpha.api/now))

  (swap! alandipert.storage-atom/transit-write-handlers merge write-handlers)

  )
